export const FETCH_INTERACTIONS_STARTED = 'nestedInteractions/FETCH_INTERACTIONS_STARTED';
export const STORE_INTERACTIONS = 'nestedInteractions/STORE_INTERACTIONS';
export const SET_PARAMS = 'nestedInteractions/SET_PARAMS';
export const SET_IS_REFRESH_REQUIRED = 'nestedInteractions/SET_IS_REFRESH_REQUIRED';
export const CLEAR_INTERACTIONS = 'nestedInteractions/CLEAR_INTERACTIONS';
export const SHOW_MODAL = 'nestedInteractions/SHOW_MODAL';
export const HIDE_MODAL = 'nestedInteractions/HIDE_MODAL';
